<div class="sticky app-navigation-bar">
    <div class="horizontal-main clearfix">
        <div class="horizontal-mainwrapper container-fluid">
            
            <div class="d-flex align-items-center justify-content-start w-100">
                
                <a class="header-brand-nav d-flex align-items-center mr-5" routerLink="/admin/dashboard">
                    <img src="../../../../../assets/images/brand/astro1.png" class="nav-logo-img" alt="Astro Logo">
                </a>
                
                <nav class="horizontalMenu">
                    <ul class="horizontalMenu-list d-flex">
                        
                        <li aria-haspopup="true">
                            <a [routerLink]="['/admin/dashboard']" class="nav-link-item">Dashboard</a>
                        </li>
                        
                        <li aria-haspopup="true" *appHasRole="['Manage-Users','Manage-Astrologers','Manage-Customer','Manage-Managers']">
                            <a href="javascript:void(0)" class="nav-link-item sub-icon">
                                User Type <i class="fa fa-angle-down menu-dropdown-icon"></i>
                            </a>
                            <ul class="sub-menu shadow-lg">
                                <li aria-haspopup="true" *appHasRole="['Manage-Users']"><a [routerLink]="['/admin/usersList']">All Users</a></li>
                                <li aria-haspopup="true" *appHasRole="['Manage-Astrologers']"><a [routerLink]="['/admin/astro/approved']">Astrologer</a></li>
                                <li aria-haspopup="true" *appHasRole="['Manage-Customer']"><a [routerLink]="['/admin/customer/list']">Customer</a></li>
                            </ul>
                        </li>

                        <li aria-haspopup="true" *appHasRole="['Manage-Orders']">
                            <a [routerLink]="['/admin/order/all']" class="nav-link-item">Orders</a>
                        </li>
                        
                        <li aria-haspopup="true" *appHasRole="['Manage-Request']">
                            <a href="javascript:void(0)" class="nav-link-item sub-icon">
                                Requests <i class="fa fa-angle-down menu-dropdown-icon"></i>
                            </a>
                            <ul class="sub-menu shadow-lg">
                                <li aria-haspopup="true"><a [routerLink]="['/admin/request/charges']">Charges Update</a></li>
                                <li aria-haspopup="true"><a [routerLink]="['/admin/request/profile']">Profile Update</a></li>
                            </ul>
                        </li>

                        <li aria-haspopup="true">
                            <a href="javascript:void(0)" class="nav-link-item sub-icon">
                                Guidance <i class="fa fa-angle-down menu-dropdown-icon"></i>
                            </a>
                            <ul class="sub-menu shadow-lg">
                                <li aria-haspopup="true"><a [routerLink]="['/admin/guidance-category/list']">Guidance Category</a></li>
                                <li aria-haspopup="true"><a [routerLink]="['/admin/guidance-card/list']">Guidance Cards</a></li>
                                <li aria-haspopup="true"><a [routerLink]="['/admin/guidance-detail/list']">Guidance Detail</a></li>
                            </ul>
                        </li>

                        <li aria-haspopup="true" *appHasRole="['Manage-Offers']">
                            <a [routerLink]="['/admin/offers/all']" class="nav-link-item">Offers</a>
                        </li>

                        <li aria-haspopup="true" *appHasRole="['Manage-Blog']">
                            <a href="javascript:void(0)" class="nav-link-item sub-icon">
                                Blogs <i class="fa fa-angle-down menu-dropdown-icon"></i>
                            </a>
                            <ul class="sub-menu shadow-lg">
                                <li aria-haspopup="true"><a [routerLink]="['/admin/blog-category/list']">Blog Category</a></li>
                                <li aria-haspopup="true"><a [routerLink]="['/admin/blog/new']">Blogs</a></li>
                            </ul>
                        </li>

                        <li aria-haspopup="true" *appHasRole="['Manage-Festivals']">
                            <a href="javascript:void(0)" class="nav-link-item sub-icon">
                                Festivals <i class="fa fa-angle-down menu-dropdown-icon"></i>
                            </a>
                            <ul class="sub-menu shadow-lg">
                                <li aria-haspopup="true"><a [routerLink]="['/admin/festival/list']">List</a></li>
                                <li aria-haspopup="true"><a [routerLink]="['/admin/festival/list-yearly']">List Yearly Festivals</a></li>
                            </ul>
                        </li>

                        <li aria-haspopup="true" *appHasRole="['Manage-Mall']">
                            <a href="javascript:void(0)" class="nav-link-item sub-icon">
                                Astro Shop <i class="fa fa-angle-down menu-dropdown-icon"></i>
                            </a>
                            <ul class="sub-menu shadow-lg">
                                <li aria-haspopup="true"><a [routerLink]="['/admin/order/store']">Orders</a></li>
                                <li aria-haspopup="true"><a [routerLink]="['/admin/mall-category/list']">Category</a></li>
                                <li aria-haspopup="true"><a [routerLink]="['/admin/mall-subcategory/list']">Sub-Category</a></li>
                                <li aria-haspopup="true"><a [routerLink]="['/admin/mall-product/list']">Product</a></li>
                                <li aria-haspopup="true"><a [routerLink]="['/admin/mall-coupon/list']">Coupon</a></li>
                            </ul>
                        </li>

                        <li aria-haspopup="true" *appHasRole="['Manage-Skills','Manage-Language','Manage-Report','Manage-Banner','Manage-Coupon','Manage-Roles','Manage-Customization']">
                            <a href="javascript:void(0)" class="nav-link-item sub-icon">
                                Add on <i class="fa fa-angle-down menu-dropdown-icon"></i>
                            </a>
                            <ul class="sub-menu shadow-lg">
                                <li aria-haspopup="true" *appHasRole="['Manage-Skills']"><a [routerLink]="['/admin/skills']">Skills</a></li>
                                <li aria-haspopup="true" *appHasRole="['Manage-Language']"><a [routerLink]="['/admin/languages']">Languages</a></li>
                                <li aria-haspopup="true" *appHasRole="['Manage-Report']"><a [routerLink]="['/admin/reports']">Report</a></li>
                                <li aria-haspopup="true" *appHasRole="['Manage-Banner']"><a [routerLink]="['/admin/banner']">Banner</a></li>
                                <li aria-haspopup="true" *appHasRole="['Manage-Coupon']"><a [routerLink]="['/admin/coupon']">Coupon</a></li>
                                <li aria-haspopup="true" *appHasRole="['Push-Notifications']"><a [routerLink]="['/admin/push-notification/send']">Send Notification</a></li>
                                <li aria-haspopup="true" *appHasRole="['Push-Notifications']"><a [routerLink]="['/admin/push-notification/send']">Astrologer Notice-Board</a></li>
                            </ul>
                        </li>

                        <li aria-haspopup="true" *appHasRole="['Waiting-List','Reviews','Manage-Issues','Manage-Remedy','Admin-Wallet','Manage-Orders','Manage-Request','Payout']">
                            <a href="javascript:void(0)" class="nav-link-item sub-icon">
                                Extra <i class="fa fa-angle-down menu-dropdown-icon"></i>
                            </a>
                            <ul class="sub-menu shadow-lg">
                                <li aria-haspopup="true" *appHasRole="['Waiting-List']"><a [routerLink]="['/admin/waiting-list']">Waiting List</a></li>
                                <li aria-haspopup="true" *appHasRole="['Reviews']"><a [routerLink]="['/admin/review/list']">Review</a></li>
                                <li aria-haspopup="true" *appHasRole="['Manage-Issues']"><a [routerLink]="['/admin/issue/customer']">Issues</a></li>
                                <li aria-haspopup="true" *appHasRole="['Manage-Support']"><a [routerLink]="['/admin/support/customer']">Support</a></li>
                                <li aria-haspopup="true" *appHasRole="['Manage-Remedy']"><a [routerLink]="['/admin/remedy']">Remedy</a></li>
                                <li aria-haspopup="true" *appHasRole="['Admin-Wallet']"><a [routerLink]="['/admin/wallet/list']">Admin Wallet</a></li>
                                <li aria-haspopup="true" *appHasRole="['Payout']"><a [routerLink]="['/admin/payout/history']">Astrologer Payout</a></li>
                                <li aria-haspopup="true" *appHasRole="['Notes']"><a [routerLink]="['/admin/notes']">Notes</a></li>
                                <li aria-haspopup="true" *appHasRole="['Waiting-List']"><a [routerLink]="['/admin/recharge/all']">Customer Wallet Recharge</a></li>
                            </ul>
                        </li>
                    </ul>
                </nav>

                <div class="dropdown d-flex align-items-center ml-auto user-profile-nav-area">
                    <a href="javascript:void(0)" class="nav-link profile-toggle-nav" (click)="isShow = !isShow">
                        <img *ngIf="isAdmin == 'true'" src="../../../../../assets/images/users/male/header.png"
                            alt="profile-user" class="avatar profile-avatar-nav">
                        <img *ngIf="isAdmin == 'false'" [src]="getSanitizeUrl(profileImage)" alt="profile-user"
                            class="avatar profile-avatar-nav">
                    </a>
                    <div class="dropdown-menu dropdown-menu-right dropdown-menu-arrow profile-dropdown-menu-nav" [ngClass]="{'show': isShow}">
                        <div class="drop-heading border-bottom pb-3">
                            <h5 class="text-dark mb-1">{{loginUserName}}</h5>
                            <small class="text-muted">{{loginUserEmail}}</small>
                        </div>
                        <a class="dropdown-item" [routerLink]="['/admin/users/changePassword/', userId]">
                            <i class="fe fe-lock mr-2"></i> <span>Change Password</span>
                        </a>
                        <button class="dropdown-item" (click)="onLogout()">
                            <i class="fe fe-log-out mr-2"></i> <span>Logout</span>
                        </button>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>